import { render } from "./Spoed2.vue?vue&type=template&id=2b04536a&scoped=true"
import script from "./Spoed2.vue?vue&type=script&lang=js"
export * from "./Spoed2.vue?vue&type=script&lang=js"

import "./Spoed2.vue?vue&type=style&index=0&id=2b04536a&scoped=true&lang=css"

import exportComponent from "/Users/alialsaady/Documents/repos/tandzorggestel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b04536a"]])

export default __exports__